import ApiV2 from './ApiV2';
import Sistema from '../constants/Sistema';

class LogService {
  static logAcesso(id_usuario, id_entidade, id_matricula) {
    const { pathname, hash } = window.location;

    return ApiV2.post('/log/create', {
      id_usuario,
      id_entidade,
      id_matricula,
      id_sistema: Sistema.PORTAL_EGRESSO,
      rota: `${pathname}${hash}`,
    });
  }
}

export default LogService;
